var styles = {"tabHover":"Item-module_tabHover__EOi7Q","selected":"Item-module_selected__3Zl1y"};

export { styles as default };
